"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChainInfo = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _utils = require("@chain-registry/utils");
var ChainInfo = /*#__PURE__*/function () {
  function ChainInfo(options) {
    (0, _classCallCheck2["default"])(this, ChainInfo);
    (0, _defineProperty2["default"])(this, "chainName", void 0);
    (0, _defineProperty2["default"])(this, "fetcher", void 0);
    (0, _defineProperty2["default"])(this, "_chain", void 0);
    (0, _defineProperty2["default"])(this, "_assetList", void 0);
    (0, _defineProperty2["default"])(this, "_assetLists", void 0);
    (0, _defineProperty2["default"])(this, "_ibcData", []);
    this.chainName = options.chainName;
    this.fetcher = options.fetcher;
    this.refresh();
  }
  (0, _createClass2["default"])(ChainInfo, [{
    key: "refresh",
    value: function refresh() {
      this._assetList = this.fetcher.getChainAssetList(this.chainName);
      this._ibcData = this.fetcher.getChainIbcData(this.chainName);
      this._chain = this.fetcher.getChain(this.chainName);
      var supportedChains = this._ibcData.reduce(function (m, v) {
        if (!m.includes(v.chain_1.chain_name)) m.push(v.chain_1.chain_name);
        if (!m.includes(v.chain_2.chain_name)) m.push(v.chain_2.chain_name);
        return m;
      }, []);
      this._assetLists = this.fetcher.assetLists.filter(function (list) {
        return supportedChains.includes(list.chain_name);
      });
    }
  }, {
    key: "chain",
    get: function get() {
      return this._chain;
    }
  }, {
    key: "nativeAssetList",
    get: function get() {
      return this._assetList;
    }
  }, {
    key: "assetLists",
    get: function get() {
      return (0, _utils.getAssetLists)(this.chainName, this._ibcData, this._assetLists);
    }
  }]);
  return ChainInfo;
}();
exports.ChainInfo = ChainInfo;